import React from 'react';
import { SkeletonText } from '../../common/AiSkeleton';

/**
 * 사이드바 '최근 질의 내역' 로딩을 위한 스켈레톤 UI.
 */
const ChatSidebarSkeleton = ({ count = 5 }) => {
    return (
        <div className="space-y-4 px-2">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="flex items-center gap-3">
                    {/* 메시지 아이콘 자리 */}
                    <div className="w-8 h-8 rounded-lg bg-gray-200/50 animate-pulse flex-shrink-0" />
                    {/* 텍스트 내용 자리 */}
                    <div className="flex-1 space-y-2">
                        <SkeletonText width="80%" className="h-3 opacity-60" />
                        <SkeletonText width="40%" className="h-2 opacity-30" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ChatSidebarSkeleton;
